/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCrpRecommendations extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCrpRecommendations");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCrpRecommendations.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCrpRecommendations>): BackgroundJobPayloadForCrpRecommendations {
        let obj = Object.assign(new BackgroundJobPayloadForCrpRecommendations(), model);
        BackgroundJobPayloadForCrpRecommendations.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCrpRecommendations>): BackgroundJobPayloadForCrpRecommendations {
        if (!model) return null;
        return BackgroundJobPayloadForCrpRecommendations.newInstance(<BackgroundJobPayloadForCrpRecommendations> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCrpRecommendations) {
        if (!obj) return;

        models.BackgroundJobPayloadForCrpRecommendations.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCrpRecommendations): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCrpRecommendations.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

}
